import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { SectionWiseEmailService } from './section-wise-email.service';
import { HttpClient } from '@angular/common/http';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-section-wise-email',
  templateUrl: './section-wise-email.component.html',
  styleUrl: './section-wise-email.component.scss'
})
export class SectionWiseEmailComponent {
  public Editor = ClassicEditor;

  selectedSection: string = 'IP';
  headerImagePath: string = 'assets/images/SectionWiseEmail.jpg';
  bodyHtml: string = ``;

  isDialogVisible = false;
  isSendingMail = false;
  previewHtml: string = '';

  private editorInstance: any;

  email: string = '';
  subject: string = '';

  constructor(
    private sanitizer: DomSanitizer,
    private toastr: ToastrService,
    private svc: SectionWiseEmailService,
    private http: HttpClient,
  ) { }

  ngOnInit(): void {
    this.email = (localStorage.getItem('email') || '').trim();
    this.updatePreviewHtml();
  }

  onSectionChange() {
    this.updatePreviewHtml();
  }

  onEditorReady(editor: any) {
    this.editorInstance = editor;
  }

  onBodyChange() {
    this.updatePreviewHtml();
  }

  openPreviewDialog() {
    this.previewHtml = this.buildEmailHtmlForPreview();
    this.isDialogVisible = true;
  }

  sanitizeHtml(content: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(content || '');
  }

  private getBodyHtmlLive(): string {
    try {
      const live = this.editorInstance?.getData?.();
      return (live && live.trim().length) ? live : (this.bodyHtml || '');
    } catch {
      return this.bodyHtml || '';
    }
  }

  private updatePreviewHtml() {
    this.previewHtml = this.buildEmailHtmlForPreview();
  }

  sendMailFromDialog() {
    if (!this.email) {
      this.toastr.error('User email not found in localStorage.');
      return;
    }

    if (!this.subject || !this.subject.trim()) {
      this.toastr.error('Subject is required.');
      return;
    }

    const htmlToSend = this.buildEmailHtmlForSend();
    if (!htmlToSend || htmlToSend.trim().length < 10) {
      this.toastr.error('Email content is empty.');
      return;
    }

    const payload = {
      user_email: this.email,
      html_content: htmlToSend,
      section: `${this.selectedSection}_section`,
      subject: this.subject.trim(),
    };

    this.isSendingMail = true;

    this.svc.sendSectionWiseEmail(payload).subscribe({
      next: (res: any) => {
        this.isSendingMail = false;
        this.toastr.success(res?.message || 'Mail sent successfully!');
        this.isDialogVisible = false;
      },
      error: (err) => {
        this.isSendingMail = false;

        const apiMsg =
          err?.error?.error ||
          err?.error?.message ||
          err?.message ||
          'Error sending mail. Please try again!';

        this.toastr.error(apiMsg);
      }
    });
  }

private wrapWithEmailTemplate(bodyHtml: string, headerImgSrc: string): string {
  const bodyWithBorders = this.forceInlineTableBorders(bodyHtml);

  return `
    <div style="max-width:650px;margin:0 auto;font-family:Arial,sans-serif;background:#fff;border-radius:10px;overflow:hidden;">
      <img src="${headerImgSrc}"
           alt="Header"
           style="display:block;width:100%;max-width:650px;height:auto;border:0;" />
      <div style="padding:18px;">
        ${bodyWithBorders}

        <div style="margin-top:28px;font-size:13px;line-height:1.4;">
          <div style="color:#333;">By regards</div>
          <div style="color:#1a3fb5;font-weight:700;">PharSights Info</div>
        </div>
      </div>
    </div>
  `;
}


  private buildEmailHtmlForSend(): string {
    const body = this.getBodyHtmlLive();
    const headerSrc = this.getPublicHeaderUrl();
    return this.wrapWithEmailTemplate(body, headerSrc);
  }

  private buildEmailHtmlForPreview(): string {
    const body = this.getBodyHtmlLive();
    const headerSrc = 'assets/images/SectionWiseEmail.jpg';
    return this.wrapWithEmailTemplate(body, headerSrc);
  }

  private getPublicHeaderUrl(): string {
    return `${window.location.origin}/assets/images/SectionWiseEmail.jpg`;
  }

private forceInlineTableBorders(html: string): string {
  if (!html) return html;

  try {
    const doc = new DOMParser().parseFromString(`<div id="root">${html}</div>`, 'text/html');
    const root = doc.getElementById('root');
    if (!root) return html;

    // tables
    root.querySelectorAll('table').forEach((t) => {
      t.setAttribute('border', '1');
      t.setAttribute('cellpadding', '6');
      t.setAttribute('cellspacing', '0');

      const s = t.getAttribute('style') || '';
      t.setAttribute(
        'style',
        `${s};border-collapse:collapse;border-spacing:0;width:100%;border:1px solid #000;`
      );
    });

    // cells
    root.querySelectorAll('th,td').forEach((c) => {
      const s = c.getAttribute('style') || '';
      c.setAttribute('style', `${s};border:1px solid #000;padding:6px;vertical-align:top;`);
    });

    return root.innerHTML;
  } catch {
    return html;
  }
}
}
